// extracted by mini-css-extract-plugin
export var aircallIframe = "_m0-3";
export var fabContainer = "_m0-5";
export var fabRinging = "_m0-6";
export var loadingOverlay = "_m0-4";
export var pulse = "_m0-7";
export var widgetContent = "_m0-2";
export var widgetPanel = "_m0-0";
export var widgetPanelExpanded = "_m0-1";